import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { AppProvider } from './context/AppContext';
import Routes from './routes';
import GlobalStyle from './styles/global';
import './styles/index.css';

import './styles/index.css';

const TRACKING_ID = "G-ZX2Q79RFFP";
ReactGA.initialize(TRACKING_ID);


function App() {

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <AppProvider>
      <GlobalStyle />
      <Routes />
    </AppProvider>
  );
}

export default App;
